import React, { useCallback } from "react";
import "../../index.css";

const Button = React.memo(({ label, onClick }) => {
  const handleClick = useCallback(() => {
    if (onClick) {
      onClick();
    }
  }, [onClick]);

  return (
    <button
      className="px-6 py-2 bg-black text-white rounded-lg font-bold text-lg duration-200 transform hover:rounded-full hover:-translate-y-1 transition"
      onClick={handleClick}
    >
      {label}
    </button>
  );
});

export default Button;
